import { PersistStorage, StorageValue } from 'zustand/middleware';
import { parse, serialize } from 'cookie';
import { TIME_CONSTANTS_IN_SECONDS } from '@ecom/helper-utils';

export function cookieStorage<T>(): PersistStorage<T> {
  return {
    getItem: (name: string): StorageValue<T> | null => {
      if (typeof document === 'undefined') return null;
      const cookies = parse(document.cookie);
      const cookie = cookies[name];
      try {
        return cookie ? (JSON.parse(cookie) as StorageValue<T>) : null;
      } catch {
        return null;
      }
    },
    setItem: (name: string, value) => {
      if (typeof document === 'undefined') return;
      document.cookie = serialize(name, JSON.stringify(value), {
        path: '/',
        maxAge: TIME_CONSTANTS_IN_SECONDS.ONE_YEAR,
      });
    },
    removeItem: (name: string) => {
      if (typeof document === 'undefined') return;
      document.cookie = serialize(name, '', {
        path: '/',
        maxAge: 0,
      });
    },
  };
}
